import { render, staticRenderFns } from "./advertisement-list.vue?vue&type=template&id=3f56d0f9&scoped=true&"
import script from "./advertisement-list.vue?vue&type=script&lang=js&"
export * from "./advertisement-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56d0f9",
  null
  
)

export default component.exports